module.exports = {
    Window: {
      defaultSize : {
        width : "460px",
        height : "430px",
          },
      defaultPosition: {
            xPos: "135px",
            yPos: "5px",
        },
      gutterSize: 20,
      hugHorizontal: "right",
      minimizeTime: 500,
    },
    Resize: {
      minHeight: 350,
      minWidth: 350,
      maxWidth: 650,
      maxHeight: 700,
    },
    
};



// WEBPACK FOOTER //
// ./settings/window.js